import { useEffect, useRef } from "react";
import confetti from "canvas-confetti";

// We'll keep a reference to the confetti function
let fireFn: ReturnType<typeof confetti.create> | null = null;

/**
 * Call this anywhere in your app to trigger fireworks.
 */
export function shootFireworks(durationMs = 1200) {
  if (!fireFn) return;

  const end = Date.now() + durationMs;
  const interval = setInterval(() => {
    fireFn!({
      particleCount: 100,
      startVelocity: 45,
      spread: 70,
      ticks: 60,
      origin: { x: 0.5, y: 0.95 }, // top half
    });
    if (Date.now() > end) clearInterval(interval);
  }, 150);
}

type Props = {
  top?: number;   // px offset from top
  left?: number;  // px offset from left
};

export default function ConfettiCanvas({ top = 0, left = 0 }: Props) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  useEffect(() => {
    if (canvasRef.current) {
      fireFn = confetti.create(canvasRef.current, {
        resize: true,
        useWorker: true,
      });
    }
    return () => {
      fireFn = null;
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="pointer-events-none inset-0 z-0"
      style={{
        position: "absolute", 
        zIndex: 9999, 
        pointerEvents: "none",
        display: "block",
        top,
        left,
        width: "600px",
        height: "600px",
      }}
    />
  );
}